import { useManageSubscription } from "features/subscriptions/context/ManageSubscriptionContext";

import { Button } from "common/components/ui/Button";

interface SubscriptionActionButtonProps {
  isDisabled: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export default function SubscriptionActionButton({
  isDisabled,
  isLoading,
  onClick,
}: SubscriptionActionButtonProps) {
  const { hasActiveSubscription, isCancellation } = useManageSubscription();

  let buttonLabel = "Create subscription";

  if (isCancellation) {
    buttonLabel = "Cancel subscription";
  } else if (hasActiveSubscription) {
    buttonLabel = "Update subscription";
  }

  return (
    <Button
      size="md"
      isLoading={isLoading}
      onClick={onClick}
      disabled={isDisabled}
    >
      {buttonLabel}
    </Button>
  );
}
